import { Auth } from "aws-amplify";
import axios from "axios";
import { logOutUser } from "lib/session/logOut";

const idTokenInterceptor = async config => {
  const newConfig = { ...config };
  /* The method currentSession will hit aws-amplify internal cache
  to get the session of the user. If the session is expired, it will
  call Cognito for new ID and Access tokens if the Refresh token is 
  not expired. If it is, the value of the Token will be undefined */
  try {
    const session = await Auth.currentSession();
    const idToken = session.getIdToken().getJwtToken();

    newConfig.headers.Authorization = idToken;
  } catch (error) {
    // Cancel the request
    const source = axios.CancelToken.source();
    newConfig.cancelToken = source.token;
    source.cancel();

    // Session is expired, redirect the user to the login
    logOutUser();
  }

  return newConfig;
};

export default idTokenInterceptor;
